import { SERVER_ERROR, UNAUTHORIZED_ERROR, EXPIRED_SESSION_ERROR } from "../Constants";

export function receivedServerError(data, message) {
    return {
        type: SERVER_ERROR,
        payload: data ? message : data
    };
}

export function receivedUnauthorizedError(data, target) {
    // if (target) {
    //     App.unblockUI(target);
    // }
    return {
        type: UNAUTHORIZED_ERROR,
        payload: data
    };
}

export function receivedExpiredSessionError(data) {
    return {
        type: EXPIRED_SESSION_ERROR,
        payload: data
    };
}